import { TimeSlot } from "@hubcapp/types";
import { useLazyQuery } from "@apollo/react-hooks";
import timeSlotsAvailability from "../graph-ql/getTimeSlotsAvailability.graphql";

const useQueryGetTimeSlotsAvailability = () =>
  useLazyQuery<{ timeSlotsAvailability: TimeSlot[] }>(timeSlotsAvailability, {
    fetchPolicy: "network-only",
  });

export default useQueryGetTimeSlotsAvailability;
